import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_LISTING_UPDATE_RENEWAL_SEGMENT_EVENT,
} from 'api/actionTypes';

export default async function updateListingRenewalSegmentEvent(
  { state, apiClient },
  {
    originalListingId,
    renewalLinkClicked,
    stoppedEmailCampaign,
    marketedOnSunroom,
    marketedOnSunroomNewListingId,
  }
) {
  typeCheck('originalListingId::PositiveNumber', originalListingId);
  typeCheck('renewalLinkClicked::Maybe DateString', renewalLinkClicked);
  typeCheck('stoppedEmailCampaign::Maybe DateString', stoppedEmailCampaign);
  typeCheck('marketedOnSunroom::Maybe DateString', marketedOnSunroom);
  typeCheck('marketedOnSunroomNewListingId::Maybe PositiveNumber', marketedOnSunroomNewListingId);

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_UPDATE_RENEWAL_SEGMENT_EVENT,
    state: state,
    payload: {
      originalListingId,
      renewalLinkClicked,
      stoppedEmailCampaign,
      marketedOnSunroom,
      marketedOnSunroomNewListingId,
    },
  });
}
